module.exports = __webpack_public_path__ + "img/inst-17.78edc812.png";